
import { AppService } from "app/services/app.service";
import { AppFilter } from "app/models/app-filter.model";
import { Observable } from "rxjs";

export abstract class AbVersaoAppLoja extends AppService {
  abstract getVersions(filter: AppFilter): Observable<any>;
  abstract verificar(id: number): Observable<any>;
  abstract getUrlLoja(id: number, loja: string): Observable<any>;
}
